import "./UploadSuccess.scss";
import { Link } from "react-router-dom";

function UploadSuccess() {
  return (
    <section className="success">
      <div className="success__container">
        <h1 className="success__heading">Video successfully uploaded!</h1>
        <Link className="success__link" to="/videos">
          <button className="success__btn">HOME</button>
        </Link>
      </div>
    </section>
  );
}

export default UploadSuccess;
